import { Injectable, ComponentRef } from '@angular/core';
import { AtpNotificationsComponent } from './atp-notifications.component';
import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';

export class AtpNotificationsSettings {
  messageType: ComponentType<any>;
  time?: number;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class AtpNotificationsService {
  constructor(private _overlay: Overlay) { }

  private _overlayRef: OverlayRef;
  private _componentRef: ComponentRef<AtpNotificationsComponent>;

  push(settings: AtpNotificationsSettings) {
    if (!this._overlayRef) {
      this._overlayRef = this._overlay.create();
      this._overlayRef.updatePositionStrategy(this._overlay.position().global().bottom('0'));
      const notificationsPortal = new ComponentPortal(AtpNotificationsComponent);
      this._componentRef = this._overlayRef.attach(notificationsPortal);
      this._componentRef.instance.addMessage(settings);
    }
    else {
      this._componentRef.instance.addMessage(settings);
    }
  }
}